__turbopack_context__.v({
  "hourForecast": "DayForecast-module-scss-module__2zZkRa__hourForecast",
  "icon": "DayForecast-module-scss-module__2zZkRa__icon",
});
